import { IDocOptions, SurveyPDF } from 'survey-pdf'

const exportToPdfOptions: IDocOptions = {
  fontSize: 12,
}

export function createExtendedPDF(
  uploader,
  survey,
  participant,
  surveyDefinition,
  questions,
  onSuccess = undefined
) {
  const surveyPdf = new SurveyPDF(
    surveyDefinition.structure,
    exportToPdfOptions
  )
  surveyPdf.data = survey.data
  surveyPdf.raw().then(function (text) {
    var blob = new Blob([text], { type: 'application/pdf' })
    console.log('uploading pdf', blob, surveyDefinition, survey.data)
    uploader.handleSelectFile(
      blob,
      undefined,
      surveyDefinition.fileName + '.pdf' || 'survey.pdf',
      onSuccess
    )
  })
}
